// extracted by css-extract-rspack-plugin
export default {"syncing-logo":"syncing-logo-e6iuUY","syncingLogo":"syncing-logo-e6iuUY","sync-icon":"sync-icon-Wwb6xS","syncIcon":"sync-icon-Wwb6xS"};